// TODO: Remove global style components

import React from 'react';

const GlobalCSSFonts = () => {
  const { pathname, host } = window.location;

  const isNotScale =
    pathname.includes('corp') || host.includes('remotasks') || host.includes('3002');

  const fontFamily = isNotScale
    ? "'Plex', -apple-system, Arial, Sans-Serif"
    : "'Inter', -apple-system, Arial, Sans-Serif";

  const katexFontFace = `@font-face {
  font-family: 'KaTeX_Main';
  src: url('https://cdn.jsdelivr.net/npm/katex@0.16.10/dist/fonts/KaTeX_Main-Regular.woff2')
    format('woff2');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'KaTeX_Math';
  src: url('https://cdn.jsdelivr.net/npm/katex@0.16.10/dist/fonts/KaTeX_Math-Italic.woff2')
    format('woff2');
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'KaTeX_AMS';
  src: url('https://cdn.jsdelivr.net/npm/katex@0.16.10/dist/fonts/KaTeX_AMS-Regular.woff2')
    format('woff2');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}`;

  const fontFace = isNotScale
    ? `@font-face {
    font-family: 'Plex';
    font-display: auto;
    src: url('/static/global/fonts/plex/IBMPlexSans-Regular.eot?#iefix');
    src: url('/static/global/fonts/plex/IBMPlexSans-Regular.eot?#iefix') format('eot'),
      url('https://fonts.gstatic.com/s/ibmplexsans/v7/zYXgKVElMYYaJe8bpLHnCwDKhdHeFaxOedc.woff2')
        format('woff2'),
      url('/static/global/fonts/plex/IBMPlexSans-Regular.woff') format('woff'),
      url('/static/global/fonts/plex/IBMPlexSans-Regular.ttf') format('truetype');
    font-weight: normal;
  }

  @font-face {
    font-family: 'Plex';
    font-display: auto;
    src: url('/static/global/fonts/plex/IBMPlexSans-Medium.eot?#iefix');
    src: url('/static/global/fonts/plex/IBMPlexSans-Medium.eot?#iefix') format('eot'),
      url('https://fonts.gstatic.com/s/ibmplexsans/v7/zYX9KVElMYYaJe8bpLHnCwDKjSL9AIFsdP3pBms.woff2')
        format('woff2'),
      url('/static/global/fonts/plex/IBMPlexSans-Medium.woff') format('woff'),
      url('/static/global/fonts/plex/IBMPlexSans-Medium.ttf') format('truetype');
    font-weight: 500;
  }

  @font-face {
    font-family: 'Plex';
    font-display: auto;
    src: url('/static/global/fonts/plex/IBMPlexSans-SemiBold.eot?#iefix');
    src: url('/static/global/fonts/plex/IBMPlexSans-SemiBold.eot?#iefix') format('eot'),
      url('https://fonts.gstatic.com/s/ibmplexsans/v7/zYX9KVElMYYaJe8bpLHnCwDKjQ76AIFsdP3pBms.woff2')
        format('woff2'),
      url('/static/global/fonts/plex/IBMPlexSans-SemiBold.woff') format('woff'),
      url('/static/global/fonts/plex/IBMPlexSans-SemiBold.ttf') format('truetype');
    font-weight: bold;
  }

  @font-face {
    font-family: 'Plex';
    font-display: auto;
    src: url('/static/global/fonts/plex/IBMPlexSans-Italic.eot?#iefix');
    src: url('/static/global/fonts/plex/IBMPlexSans-Italic.eot?#iefix') format('eot'),
      url('https://fonts.gstatic.com/s/ibmplexsans/v7/zYX-KVElMYYaJe8bpLHnCwDKhdTuF6ZJW9XjDg.woff2')
        format('woff2'),
      url('/static/global/fonts/plex/IBMPlexSans-Italic.woff') format('woff'),
      url('/static/global/fonts/plex/IBMPlexSans-Italic.ttf') format('truetype');
    font-style: italic;
  }

  ${katexFontFace}`
    : `@font-face {
    font-family: 'Inter';
    font-display: auto;
    src: url('/static/global/fonts/inter/Inter-Regular.woff2') format('woff2'),
      url('/static/global/fonts/inter/Inter-Regular.woff') format('woff'),
      url('/static/global/fonts/inter/Inter-Regular.ttf') format('truetype');
    font-weight: normal;
  }

  @font-face {
    font-family: 'Inter';
    font-display: auto;
    src: url('/static/global/fonts/inter/Inter-Medium.woff2') format('woff2'),
      url('/static/global/fonts/inter/Inter-Medium.woff') format('woff'),
      url('/static/global/fonts/inter/Inter-Medium.ttf') format('truetype');
    font-weight: 500;
  }

  @font-face {
    font-family: 'Inter';
    font-display: auto;
    src: url('/static/global/fonts/inter/Inter-SemiBold.woff2') format('woff2'),
      url('/static/global/fonts/inter/Inter-SemiBold.woff') format('woff'),
      url('/static/global/fonts/inter/Inter-SemiBold.ttf') format('truetype');
    font-weight: bold;
  }

  @font-face {
    font-family: 'Inter';
    font-display: auto;
    src: url('/static/global/fonts/inter/Inter-Italic.woff2') format('woff2'),
      url('/static/global/fonts/inter/Inter-Italic.woff') format('woff'),
      url('/static/global/fonts/inter/Inter-Italic.ttf') format('truetype');
    font-style: italic;
  }

  ${katexFontFace}`;

  return (
    <style jsx global>{`
      :root {
        --font-family: ${fontFamily};
      }
      ${fontFace}
    `}</style>
  );
};

export const GlobalCSSFontsLoading = () => {
  return (
    <style jsx global>{`
      :root {
        --font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial,
          sans-serif;
      }
    `}</style>
  );
};

export default GlobalCSSFonts;
